export interface BookingPerson {
  name: string;
  email: string;
  confirmEmail: string;
  hotelId: string;
  comments?: string;
  agentId?: string;
  referenceNo?: string;
}

export interface LessonTypeAvailability {
  periodStart?: string;
  periodEnd?: string;
}

export interface Participant {
  id: string;
  name: string;
  age?: number;
  activity: "Ski" | "Snowboard" | "";
  lessonType: string;
  timeSlot: "AM" | "PM" | "FD";
  skillLevel: string;
  lessonTypeAvailability?: LessonTypeAvailability;
  price?: number | null;
  hasLevelMismatch?: boolean;
}

export interface LessonDate {
  id: string;
  date: Date | null;
  participants: Participant[];
}

export interface BookingForm {
  captchaToken: string;
  acceptedTerms: boolean;
  bookingPerson: BookingPerson;
  lessonDates: LessonDate[];
}

// API payload types
export interface ApiBookingMemberPayload {
  name: string;
  age?: number;
  skisnowboard: "ski" | "snowboard";
  lesson_code_id: number;
  ampm: "am" | "pm" | "fd";
  ski_level: string;
  lesson_type: string;
}

export interface ApiBookingParticipantPayload {
  booking_date: string; // YYYY-MM-DD
  member: ApiBookingMemberPayload[];
}

export interface ApiBookingPayload {
  captchaToken?: string;
  name: string;
  email: string;
  confirm_email: string;
  hotel_id: number;
  comments?: string;
  agent_id?: number;
  ref_no?: string;
  participant: ApiBookingParticipantPayload[];
}

export interface ApiListResponse<T> {
  success: boolean;
  message: string;
  data: {
    items: T[];
  };
}

export interface Hotel {
  id: string;
  name: string;
}

export interface Agent {
  id: string;
  name: string;
}

export interface LessonCode {
  id: string;
  name: string;
  hours: number;
  category: "Groups" | "Private";
}

export const SKI_LEVELS = ["SK1", "SK2", "SK3", "SK4", "SK5", "SK6"];
export const SNOWBOARD_LEVELS = ["SB1", "SB2", "SB3", "SB4", "SB5", "SB6"];
